import { useContext } from "react";
import { get } from "lodash";
import { LoggedInUserContext } from "context/LoggedInUserContext";

const CheckAppPermission = ({ allowed = [], config = {}, fallback = null, children }) => {
    const { keycloak } = useContext(LoggedInUserContext);
    const permissions = [...get(keycloak, "resourceAccess.usermanagement.roles", []), ...get(keycloak, "realmAccess.roles", [])];

    const { type = "one-of", orgId } = config;
    const hasPermission =
        type === "one-of"
            ? allowed.some(permission => permissions.includes(permission))
            : type === "all-of"
            ? allowed.every(permission => permissions.includes(permission))
            : false;
    return hasPermission ? children : fallback;
};

export default CheckAppPermission;
